<template>
    <div id="item-stars" @mouseleave="turnAllStarsOff">
        <i
            v-for="star in stars"
            :key="star.id"
            :id="star.id"
            class="icon-cr"
            @mouseenter="triggerStar(star)"
            @click="selectStar(star)"
            :class="{
                'icon-star-yellow': star.isHovered || star.isSelected,
                'icon-star': !star.isHovered,
            }"
            :style="{ cursor: 'pointer' }"
        />
    </div>
</template>

<script>
    export default {
        name: 'StarsComponent',
        props: {},
        data() {
            return {
                stars: [
                    { id: 1, isSelected: false, isHovered: false },
                    { id: 2, isSelected: false, isHovered: false },
                    { id: 3, isSelected: false, isHovered: false },
                    { id: 4, isSelected: false, isHovered: false },
                    { id: 5, isSelected: false, isHovered: false },
                ],
                starsSelected: 0,
            };
        },

        methods: {
            triggerStar(activeStar) {
                this.stars.map((star) => {
                    star.isHovered = star.id <= activeStar.id;
                });
            },
            turnAllStarsOff() {
                this.stars.map((star) => {
                    star.isHovered = false;
                });
            },
            selectStar(star) {
                this.starsSelected = star.id;
                this.$emit('update-selection', this.starsSelected);
            },
        },

        watch: {
            starsSelected() {
                if (this.starsSelected > 0) {
                    this.stars.map((star) => {
                        star.isSelected = star.id <= this.starsSelected;
                    });
                }
            },
        },
    };
</script>
